/**
 * Display-only normalizer for backend job descriptions.
 * Keep it conservative and targeted to avoid unintended replacements.
 */
export function toJobDescriptionDisplayText(raw: string | null | undefined): string {
  const value = (raw ?? '').toString();
  if (!value.trim()) return '';

  // Parties -> Party (case-preserving isn't necessary for our UI)
  let next = value.replace(/\bParties\b/g, 'Party');

  // "Required For" -> "Required for"
  next = next.replace(/\bRequired\s+For\b/g, 'Required for');

  // If backend says "Required for ... in <place>", change ONLY the first standalone "in" after that phrase to "at".
  // Avoid touching words like "India" (contains "in") by requiring word boundaries.
  next = next.replace(/(\bRequired\s+for\b[\s\S]*?)\bin\b/, '$1at');

  return next;
}

